import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function OnboardingtwoReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_ONBOARDINGTWO_SUCCESS_ACTION:      
      return {        
        ...state,
        onboardingResList: action.payload.response_data,
      };
      case actionTypes.FETCH_ONBOARDINGTWO_FAIL_ACTION:      
      return {        
        ...state,
        onboardingResList:{},
      };

    default:
      return {
        ...state,
      };
  }
}
